import { flatten } from 'lodash';
import { ColumnsType } from 'antd/lib/table';

import { getColumnFilteredValue } from '../../components/table/columnFormatHelpers';
import { supportedEnergyMarkets } from '../market-prices/interface';
import { INomination } from './interface';

export const getUtilityFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('iso', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue).map(utilityId => utilityId.toString());
    }
    return filteredValue;
};

export function buildProgramIsoTableFilter(state: any) {
    const column: ColumnsType<INomination>[number] = {
        filterMultiple: true,
        filters: supportedEnergyMarkets.map(market => ({ text: market.toUpperCase(), value: market, key: market })),
        filteredValue: getUtilityFilterValue(state),
        filterSearch: (input, record) => !!record?.text?.toString()?.toLowerCase().includes(input.toLowerCase()),
    };

    return column;
}
